var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFairBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5675 16.2499L8.94626 20.7886C8.75376 21.1211 8.99376 21.5374 9.37876 21.5374H14.62C15.005 21.5374 15.245 21.1211 15.0525 20.7886L12.4313 16.2499C12.2388 15.9174 11.7588 15.9174 11.5663 16.2499H11.5675Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04149 16.0005L20.9715 16.0005C21.2635 16.0005 21.5002 15.7638 21.5002 15.4717V14.0292C21.5002 13.7372 21.2635 13.5005 20.9715 13.5005L3.04149 13.5005C2.74947 13.5005 2.51274 13.7372 2.51274 14.0292V15.4717C2.51274 15.7638 2.74947 16.0005 3.04149 16.0005Z",
    fill: "#A0A4AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 13.5011C15.0277 13.5011 17.4818 11.047 17.4818 8.01982C17.4818 4.99261 15.0277 2.53857 12.0005 2.53857C8.97333 2.53857 6.51929 4.99261 6.51929 8.01982C6.51929 11.047 8.97333 13.5011 12.0005 13.5011Z",
    fill: "#FFC22A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0886 6.54053L13.0899 9.81053L11.9999 6.54053L10.9099 9.81053L9.91113 6.54053",
    stroke: "white",
    strokeWidth: 1.66458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5894 8.17529H14.5431",
    stroke: "white",
    strokeWidth: 1.66458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45557 8.17529H10.4093",
    stroke: "white",
    strokeWidth: 1.66458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFairBalance);
export default __webpack_public_path__ + "static/media/icon_fair_balance.813084fe.svg";
export { ForwardRef as ReactComponent };